module.exports = __webpack_public_path__ + "static/img/gengduo.e4c3da3b.png";